import { getAuthToken, removeAuthToken } from "../helper/token";
import { expiredTokenHandler } from "../../redux/slices/auth-slice";
import HttpError from "../helper/HttpError";

export const uploadDocument = async (
  file,
  file_name,
  current,
  number,
  dispatch
) => {
  try {
    const extention = file.name.split(".");
    const file_name_new =
      file_name +
      `${number > 1 ? "_" + current : ""}.${extention[extention.length - 1]}`;
    const renamedFile = new File([file], file_name_new, { type: file.type });
    const formData = new FormData();
    formData.append("document", renamedFile);
    const response = await fetch(
      `${process.env.REACT_APP_API_URL}/api/user/upload-document`,
      {
        method: "POST",
        headers: {
          "x-access-token": getAuthToken(),
        },

        body: formData,
      }
    );
    if (response.ok) {
      return await response.json();
    } else {
      const { message } = await response.json();
      if (response.status === 401) {
        removeAuthToken();
        dispatch(expiredTokenHandler());
        throw new HttpError(401, message || "unauthorized user");
      } else {
        throw new HttpError(response.status, message || "something went wrong");
      }
    }
  } catch (error) {
    throw new HttpError(
      error?.status || 500,
      error?.message || "something went wrong"
    );
  }
};
